import ReactDOM from "react-dom";
import React from "react";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store, { generalContextSelector, useAppSelector } from "context/store";
import GlobalStyle from "components/styles/general";
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "components/styles/theme";

const Index = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Theme />
      </BrowserRouter>
    </Provider>
  );
};
const Theme = () => {
  const { letThereBeLight } = useAppSelector(generalContextSelector);
  return (
    <ThemeProvider theme={letThereBeLight ? darkTheme : lightTheme}>
      <GlobalStyle />
      <App />
    </ThemeProvider>
  );
};
ReactDOM.render(<Index />, document.getElementById("root"));
